var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "sidebar", attrs: { id: "sidebar-wrapper" } }, [
    _c(
      "ul",
      {
        staticClass: "sidebar-nav nav-pills nav-stacked",
        attrs: { id: "menu" }
      },
      _vm._l(_vm.menuArray, function(menu, m_index) {
        return _c(
          "li",
          {
            key: "menu-" + m_index,
            ref: menu.ref,
            refInFor: true,
            class: { active: menu.isActive },
            attrs: { id: menu.id }
          },
          [
            _c("router-link", { attrs: { to: menu.routerlink } }, [
              _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
                _c("i", { class: menu.icon })
              ]),
              _vm._v(
                "\n                " + _vm._s(menu.name) + "\n            "
              )
            ])
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45334fde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45334fde","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/CustomerSidebar.vue
// module id = null
// module chunks = 